var map = {
	"./DELUXE.jpg": 1152,
	"./DOUBLE.jpg": 1153,
	"./GENERAL.jpg": 1154,
	"./Luxary.jpg": 1155,
	"./ONCOLOGY.jpg": 1156,
	"./STANDARD.jpg": 1157,
	"./STANDARD_single.jpg": 1158,
	"./VIP.jpg": 1159,
	"./triple.jpg": 1160
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 460;



//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Rooms ^\.\/.*\.jpg$
// module id = 460
// module chunks = 0